import { render, staticRenderFns } from "./addToCart.vue?vue&type=template&id=1f298937&scoped=true&"
import script from "./addToCart.vue?vue&type=script&lang=js&"
export * from "./addToCart.vue?vue&type=script&lang=js&"
import style0 from "./addToCart.vue?vue&type=style&index=0&id=1f298937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f298937",
  null
  
)

export default component.exports